import { useQuery } from '@tanstack/react-query';

import { AlertRuleAttachments } from '@/react/portainer/observability/types';
import { withError } from '@/react-tools/react-query';
import axios from '@/react/portainer/services/axios/axios';
import { parseAxiosError } from '@/react/portainer/services/axios/utils/parseAxiosError';

import { queryKeys } from '../../queryKeys';

export function useAlertRuleAttachments<T = AlertRuleAttachments>({
  id,
  select,
  refetchInterval,
}: {
  id: number;
  select?: (data: AlertRuleAttachments) => T;
  refetchInterval?: number;
}) {
  return useQuery(
    queryKeys.attachments(id),
    async () => getAlertRuleAttachments(id),
    {
      ...withError('Unable to get alert rule attachments'),
      select,
      refetchInterval,
    }
  );
}

interface AlertRuleAttachmentsResponse {
  groups: AlertRuleAttachments;
}

export async function getAlertRuleAttachments(id: number) {
  try {
    const { data } = await axios.get<AlertRuleAttachmentsResponse>(
      `/observability/alerting/rules/${id}/environments`
    );
    return data.groups;
  } catch (error) {
    throw parseAxiosError(error);
  }
}
